import { useCallback } from 'react';
import { foasService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { FOA } from '../types';

export function useFOAs(
  options?: ResourceQueryOptions
): ResourceState<FOA> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      foasService.getAll(opts) as unknown as Promise<{ data: FOA[]; meta?: any }>,
    []
  );
  return useResourceCollection<FOA>(fetchFn, options);
}

export function useFOA(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<FOA> {
  const numericId = id ? parseInt(id, 10) : null;
  const fetchFn = useCallback(
    (foaId: number, opts?: ResourceQueryOptions) =>
      foasService.getById(foaId, opts) as unknown as Promise<FOA>,
    []
  );
  return useResourceById<FOA>(fetchFn, numericId, options);
}

export function useCreateFOA(
  onSuccess?: (data: FOA) => void
): MutationState<FOA> {
  const createFn = useCallback(
    (data: any) => foasService.create(data) as unknown as Promise<FOA>,
    []
  );
  return useCreateResource<FOA>(createFn, onSuccess);
}

export function useUpdateFOA(
  onSuccess?: (data: FOA) => void
): MutationState<FOA> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
      return foasService.update(numericId, data) as unknown as Promise<FOA>;
    },
    []
  );
  return useUpdateResource<FOA>(updateFn, onSuccess);
}

/**
 * Delete FOA using documentId
 * @param data - Full FOA object containing documentId
 */
export function useDeleteFOA(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return foasService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file

